import { FaGithub, FaLinkedin } from "react-icons/fa";
import './App.css';
import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { FaBars } from "react-icons/fa";
import Car from './img/Car.PNG';
import Expense from './img/Expense.PNG';
import Gym from './img/Gym.PNG';
import HongKongMassage from './img/HongKongMassage.PNG';
import Invent from './img/invent.PNG';
import SS from './img/SS.png';
import Logo from './img/logo.png';
import me from './img/me.jpg';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_x0vay7s",
        "template_aegk6ua",
        {
          name: formData.name,
          email: formData.email,
          message: formData.message
        },
        "0CeW4__RY1LdiCeQc"
      )
      .then(() => {
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to send message.");
      });
  };

  return (
    <div className="App">
      <div id='navbar'>
        <h2 id="logo"><img src={Logo} alt="DM Logo" /></h2>
        <ul>
          <li><a href='#hero'>Home</a></li>
          <li><a href='#about'>About</a></li>
          <li><a href='#portfolio'>Portfolio</a></li>
          <li><a href='#contact'>Contact</a></li>
        </ul>
        <FaBars className="menu-btn" onClick={() => setMenuOpen(!menuOpen)} />        
      </div>

      {menuOpen && (
          <div className="mobile-nav">
            <a href="#hero">Home</a>
            <a href="#about">About</a>
            <a href="#portfolio">Portfolio</a>
            <a href="#contact">Contact</a>
          </div>
        )}

      <div id='hero'>
        <h2>Hello, my name is</h2>
        <h1>Damon Morgan</h1>
        <h2>I'm a Web Developer</h2>
        <div id="hero-button">
          <a href="/Damon2026Resume.pdf"><button>Download Resume</button></a>
          <a href="#contact"><button>Contact</button></a>
        </div>
      </div>

      <div id='about'>
        <h1>About Me</h1>
        <img src={me} alt="Myself" />
        <p>
         I’m a web developer with a strong foundation in computer programming and a genuine interest in building web applications. I enjoy taking on challenging projects and turning ideas into functional solutions. From planning and development to deployment, I approach my work with passion, attention to detail, and respect for best practices. I focus on delivering reliable, well-structured results that exceed expectations.
        </p>
        <p>
          I offer freelance web development services focused on building modern, responsive websites and ensuring they remain secure and reliable. From designing clean websites to setting up dependable web hosting, I handle everything needed to get website online and performing at its best. I also implement essential security measures to protect websites from vulnerabilities.
        </p>
      </div>

      <div id='portfolio'>
        <h1>Portfolio</h1>
        <p>Check out some of my completed projects</p>

        <div id='cards'>
          <div id="small-card">
            <a href="https://inventory.damonmorgan.net/">
              <img src={Invent} alt="Inventory System" />
            </a>
          </div>
          <div id="small-card">
            <a href="https://expense.damonmorgan.net/">
              <img src={Expense} alt="Expense Tracker" />
            </a>
          </div>
          <div id="small-card">
            <a href="https://sourcedsavings.com/">
              <img src={SS} alt="Sourced Savings" />
            </a>
          </div>
          
        </div>

        <div id='cards'>
          <div id="small-card">
            <a href="https://gym.damonmorgan.net/">
              <img src={Gym} alt="Gym Website" />
            </a>
          </div>
          <div id="small-card">
            <a href="https://daxmedia.damonmorgan.net/">
              <img src={Car} alt="Car Website" />
            </a>
          </div>
          <div id="small-card">
            <a href="https://hongkongmassagetherapyclinic.com/">
              <img src={HongKongMassage} alt="Massage Therapy" />
            </a>
          </div>
        </div>
      </div>

      <div id='contact'>
        <h2>Get In Touch</h2>

        <form className="contact-form" onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            value={formData.name}
            onChange={handleChange}
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            value={formData.email}
            onChange={handleChange}
          />

          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            required
            value={formData.message}
            onChange={handleChange}
          />

          <button type="submit">Send</button>
        </form>
      </div>

      <div id='foot'>
        <p>Damon Morgan © 2025</p>

        <div id="foot-icons">
          <a href="https://www.linkedin.com/in/damon-morgan/">
            <FaLinkedin id="footer-icon" />
          </a>
          <a href="https://github.com/damon-morgan/">
            <FaGithub id="footer-icon" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
